import type { ReactNode } from 'react';
import cn from 'classnames';
import Title from '@creditflowresearch/uilib/Title/Title';
import { CustomizationPanelTabs } from './CustomizationPanelTabs';
import { ColumnsTabContent } from './ColumnsTabContent';
import { CUSTOMIZATION_PANEL_TAB_IDS, type CustomizationPanelTabId } from './constants';

import styles from './customizationPanel.module.scss';

interface IBondScreenerCustomizationPanelProps {
  activeTab: CustomizationPanelTabId,
  onTabChange: (tabId: CustomizationPanelTabId) => void,
  resetKey: string | number,
  viewSelect: ReactNode,
  filtersContent: ReactNode,
  showScopeColumn?: boolean,
}

export const BondScreenerCustomizationPanel = ({
  activeTab,
  onTabChange,
  resetKey,
  viewSelect,
  filtersContent,
  showScopeColumn,
}: IBondScreenerCustomizationPanelProps) => (
  <div className={ styles.panel } data-test="customizationPanel">
    <Title title="Customization" tag="h1" className={ styles.title } dataTest="customizationPanelHeader" />
    { viewSelect }
    <CustomizationPanelTabs activeTab={ activeTab } onTabChange={ onTabChange } className={ styles.tabsWrapper } />
    <div className={ cn({ [styles.tabContentHidden]: activeTab !== CUSTOMIZATION_PANEL_TAB_IDS.FILTERS }) }>
      { filtersContent }
    </div>
    <div className={ cn({ [styles.tabContentHidden]: activeTab !== CUSTOMIZATION_PANEL_TAB_IDS.COLUMNS }) }>
      <ColumnsTabContent activeTab={ activeTab } resetKey={ resetKey } showScopeColumn={ showScopeColumn } />
    </div>
  </div>
);
